import { useTranslation } from "@opendash/i18n";
import { Tour, TourProps } from "antd";
import React, { useState } from "react";
import { useUserGuideSelect } from "../../../hooks/useUserGuideSelect";
import { TourId } from "../../../types/TourId";
import TourButton from "../TourButton";

export default () => {
  const t = useTranslation();
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState(0);
  const select = useUserGuideSelect<TourId.Route>();

  const steps: TourProps["steps"] = [
    {
      title: t("gtfs:tour.route.start.title"),
      description: t("gtfs:tour.route.start.description"),
    },
    {
      title: t("gtfs:tour.route.create.title"),
      description: t("gtfs:tour.route.create.description"),
      target: () => select(TourId.Route.create),
      onNext() {
        select(TourId.Route.create)?.click();
        setTimeout(() => setCurrent((prev) => prev + 1), 500);
      },
    },
    {
      title: t("gtfs:tour.route.formular.title"),
      description: t("gtfs:tour.route.formular.description"),
      target: () => select(TourId.Route.modal),
      onPrev() {
        select(TourId.Route.close)?.click();
        setCurrent((prev) => prev - 1);
      },
    },
    {
      title: t("gtfs:tour.route.save.title"),
      description: t("gtfs:tour.route.save.description"),
      target: () => select(TourId.Route.save),
      onNext() {
        select(TourId.Route.close)?.click();
        select(TourId.Route.card)?.setAttribute("style", "display: block");
        setCurrent((prev) => prev + 1);
      },
    },
    {
      title: t("gtfs:tour.route.overview.title"),
      description: t("gtfs:tour.route.overview.description"),
      target: () => select(TourId.Route.overview),
      onPrev() {
        select(TourId.Route.card)?.setAttribute("style", "display: none");
        select(TourId.Route.create)?.click();
        select(TourId.Route.save)?.scrollTo();
        setTimeout(() => setCurrent((prev) => prev - 1), 500);
      },
    },
    {
      title: t("gtfs:tour.route.card.title"),
      description: t("gtfs:tour.route.card.description"),
      target: () => select(TourId.Route.card),
    },
    {
      title: t("gtfs:tour.route.card.header.title"),
      description: t("gtfs:tour.route.card.header.description"),
      target: () => select(TourId.Route.cardHeader),
    },
    {
      title: t("gtfs:tour.route.card.body.title"),
      description: t("gtfs:tour.route.card.body.description"),
      target: () => select(TourId.Route.cardBody),
    },
    {
      title: t("gtfs:tour.route.card.action.trip.title"),
      description: t("gtfs:tour.route.card.action.trip.description"),
      target: () => select(TourId.Route.cardActionTrip),
    },
    {
      title: t("gtfs:tour.route.card.action.delete.title"),
      description: t("gtfs:tour.route.card.action.delete.description"),
      target: () => select(TourId.Route.cardActionDelete),
    },
    {
      title: t("gtfs:tour.route.card.action.edit.title"),
      description: t("gtfs:tour.route.card.action.edit.description"),
      target: () => select(TourId.Route.cardActionEdit),
    },
    {
      title: t("gtfs:tour.route.done.title"),
      description: t("gtfs:tour.route.done.description"),
    },
  ];

  function onEndTour() {
    setOpen(false);
    setCurrent(0);
    select(TourId.Route.card)?.setAttribute("style", "display: none");
    select(TourId.Route.close)?.click();
  }

  return (
    <>
      <TourButton
        onClick={() => setOpen(true)}
        title={t("gtfs:tour.route.button.title")}
      />
      <Tour
        steps={steps}
        open={open}
        onClose={() => onEndTour()}
        current={current}
        onChange={(cur) => setCurrent(cur)}
      />
    </>
  );
};
